module.exports = __webpack_public_path__ + "static/media/Design.a98181f9.png";